import { render, staticRenderFns } from "./rfidToolMgr.vue?vue&type=template&id=5287f4cd&scoped=true"
import script from "./rfidToolMgr.vue?vue&type=script&lang=js"
export * from "./rfidToolMgr.vue?vue&type=script&lang=js"
import style0 from "./rfidToolMgr.vue?vue&type=style&index=0&id=5287f4cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5287f4cd",
  null
  
)

export default component.exports